import styled from 'styled-components'

export const CategoryDiv = styled.div`
  padding: 0.313em;
  display: list-item;
  text-align: -webkit-match-parent;
  text-transform: capitalize;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
`



// WEBPACK FOOTER //
// ./src/components/Elements/Sidebar/styles/CategoryDiv.js